var map = {
	"./Andrea McLeod-Karim.jpg": 1176,
	"./Anjan Sahu.jpg": 1177,
	"./Manohara Raj Karuppasamy.png": 1178,
	"./Michael O’Sullivan UCC.jpg": 1179,
	"./Mrs Nair.png": 1180,
	"./Nicholas Venn Springfield College.jpg": 1181,
	"./Pratik-giri.jpg": 1182,
	"./Praveen raval.57a24d7.jpg": 1183,
	"./Praveen raval.jpg": 1184,
	"./Rylan James.jpg": 1185,
	"./Shahina Khaitri.jpg": 1186,
	"./anjan.jpg": 1187,
	"./asif.png": 1188,
	"./avtar-1.png": 1189,
	"./fair-1.png": 1190,
	"./fair-2.png": 1191,
	"./fair-3.png": 1192,
	"./fair-4.png": 1193,
	"./fair-5.png": 1194,
	"./fair-6.png": 1195,
	"./img-1.png": 1196,
	"./mahonaraj.png": 1197,
	"./mehoonri.jpg": 1198,
	"./prathamesh.jpg": 1199,
	"./rylan.jpg": 1200,
	"./sandeep.jpg": 1201,
	"./seeneen mulla.jpg": 1202,
	"./shahnia.jpg": 1203,
	"./siddhi.jpg": 1204,
	"./sinjo.jpg": 1205,
	"./sonia.jpg": 1206
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial ^\.\/.*$
// module id = 365
// module chunks = 1